import { Form, Formik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from 'react-router-dom';
import { Route as RouteNeo } from '~/Constants/Routes.constants';
import { CopyrightFooter, Error } from '../../Components';
import { makeStyles } from '~/UIKit/Style';
import {
  OnboardingDetails,
  OnboardingHeader,
  OnboardingSideSplash,
  OnboardingStudio,
  OnboardingVerification,
  useOnboarding,
} from './';
import { onboardingValidationScheme } from './helpers/useVerification';
import { Helmet } from 'react-helmet';

const { ONBOARDING_DETAILS, ONBOARDING_STUDIO, ONBOARDING_VERIFICATION } = RouteNeo;

const useStyles = makeStyles((theme) => ({
  onboardingContainerWrapper: {
    overflow: 'overlay',
    maxHeight: '100vh',
  },
  onboardingContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    width: 1200,
    minWidth: '100%',
    position: 'relative',
    letterSpacing: 0.5,
    fontWeight: 300,
    fontSize: '13px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
      height: 'auto',
      width: 'auto',
      minWidth: 'auto',
    },
  },
  onboardingContent: {
    overflowY: 'auto',
    flex: 1,
  },
}));

export const Onboarding = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const {
    initialValues,
    validateForm,
    page,
    countryList,
    categoryList,
    isStudioSetupDone,
    isStudioDetailsDone,
    isAlreadyAProvider,
    isAlreadyAUser,
    networkError,
    onDoneSettingUpStudio,
    onCreateProviderAccount,
    onRedirectToLogin,
    onResendEmail,
    isLoading,
    isPasswordWrong,
  } = useOnboarding();
  return (
    <div className={classes.onboardingContainerWrapper}>
      <Helmet>
        <title>{t('SEO.onboarding.title')}</title>
        <meta name="description" content={t('SEO.onboarding.description')} />
      </Helmet>
      <div className={classes.onboardingContainer}>
        <OnboardingSideSplash pageName={page} />
        <div className={classes.onboardingContent}>
          <OnboardingHeader />
          <Formik
            initialValues={initialValues}
            onSubmit={() => {}}
            validate={validateForm}
            enableReinitialize
            validationSchema={() => onboardingValidationScheme(t, isAlreadyAUser)}
          >
            {({ isValid, errors, touched }) => (
              <Form>
                <Error error={networkError} />
                <Route exact path={ONBOARDING_STUDIO}>
                  <OnboardingStudio
                    countryList={countryList}
                    studioTypes={categoryList}
                    isStudioSetupDone={isStudioSetupDone}
                    onDoneSettingUpStudio={onDoneSettingUpStudio}
                    errors={errors}
                    touched={touched}
                  />
                </Route>
                <Route exact path={ONBOARDING_DETAILS}>
                  <OnboardingDetails
                    isStudioDetailsDone={isValid && isStudioDetailsDone}
                    onCreateProviderAccount={onCreateProviderAccount}
                    onRedirectToLogin={onRedirectToLogin}
                    isAlreadyAProvider={isAlreadyAProvider}
                    isAlreadyAUser={isAlreadyAUser}
                    isPasswordWrong={isPasswordWrong}
                    errors={errors}
                    touched={touched}
                  />
                </Route>
                <Route exact path={ONBOARDING_VERIFICATION}>
                  <OnboardingVerification onResendEmail={onResendEmail} isLoading={isLoading} />
                </Route>
              </Form>
            )}
          </Formik>
          <CopyrightFooter />
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
